import {useLocation} from 'react-router-dom';
import {  useState } from "react";
import { useNavigate } from "react-router-dom";
import './Lobby.css';
import axios from 'axios';
import RuangList from './Components/RuangList';
import SessionInformation from './Components/SessionInformation';
import LobbyTimer from './Components/LobbyTimer';
import Broadcast from './Components/Broadcast';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer,NotificationManager} from 'react-notifications';

const Lobby = () => {
	const location = useLocation();
	const navigate = useNavigate();
	let userData = location.state.userData
	userData['uid_screen'] = parseInt(userData['uid_screen'])
	let sessionData = location.state.sesi
	let roleUser = userData['role_peserta']
	const [timesUp, setTimesUp] = useState(false)

	const handleJoinDiskusi = async (link, event) => {
		let index = link.id
		if(!timesUp){
			const ruangDiskusiData = { 'uid_peserta': userData['uid_peserta'], 'uid_screen': userData['uid_screen'], 'channel_name': index};
			const response = await axios.post('https://backend-ta-wiyata.herokuapp.com/get-token/', ruangDiskusiData);
			navigate("/room", {
				state:{
					userData:{...userData, index}, tokenData: response.data, sessionData: sessionData, roomName: link.nama_ruang
				}});
		}else{
			if(roleUser == 'HOST'){
				NotificationManager.error('Session has ended, Room has been closed', 'Error');
			}
			else{
				navigate("/postcall", {
					state:{
						userUid: userData['uid_peserta'],
						roomId:index
					}
				});
			}
		}
	}
	const handleTimesUp = () =>{
		setTimesUp(true)
	}
	const handleToReport = () => {
		navigate("/report", {
			state:{
				sessionData: sessionData,
				userData: userData
			}
		});
	}
	return (
		<div class="lobby">
			<div class="lobby__header">
				<LobbyTimer time={sessionData['waktu_akhir']} handleTimesUp={handleTimesUp} />
				<div class="profile">
					<p>{userData['nama_peserta']}</p>
					<p>{roleUser==='HOST'? <span>Host</span> : <span>Student</span>}</p>
					<p>{roleUser==='STUDENT'? <span>{userData['npm_peserta']}</span> : null}</p>
				</div>
			</div>
			<div class="lobby__content-wrapper">
				<div class="sesi">
					<h2>Lobby Room</h2>
					<SessionInformation sessionData={sessionData} roleUser={roleUser}/>
					{roleUser === 'HOST' ? 
						!timesUp ? 
						<Broadcast sessionData={sessionData} userData={userData}/>
						: <div class="sesi__report-button"><button class="wiyata-btn" onClick={handleToReport}>View Report</button></div>
					: null }
				</div>
				<RuangList timesUp={timesUp} sessionId={sessionData.id} roleUser={roleUser} handleJoinDiskusi={handleJoinDiskusi}/>
			</div>
			<NotificationContainer/>
		</div>
	);
}
 
export default Lobby;